export default function WhyChooseSection() {
  return (
    <section className='min-h-screen w-full bg-white flex items-center justify-center px-4 md:px-6 lg:px-10 py-16 md:py-20 lg:py-24'>
      <div className='max-w-[1400px] w-full'>
        {/* Section Title */}
        <h2 className='text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 text-center mb-16 md:mb-20 lg:mb-24'>
          Why Choose Podus Checker
        </h2>

        {/* Features Grid */}
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 lg:gap-12'>
          {/* Verified Accuracy */}
          <div className='bg-gray-50 rounded-3xl p-8 md:p-10 lg:p-12 hover:bg-gray-100 transition-colors'>
            <div className='w-16 h-16 md:w-20 md:h-20 bg-white rounded-2xl flex items-center justify-center mb-6 md:mb-8'>
              <svg
                className='w-8 h-8 md:w-10 md:h-10 text-[#FF6B35]'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={2}
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                />
                <circle cx='12' cy='12' r='3' fill='currentColor' />
              </svg>
            </div>
            <h3 className='text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4'>
              Verified Accuracy
            </h3>
            <p className='text-gray-700 text-sm md:text-base leading-relaxed'>
              All data is sourced from official records and trusted institutions.
            </p>
          </div>

          {/* Fast Turnaround */}
          <div className='bg-gray-50 rounded-3xl p-8 md:p-10 lg:p-12 hover:bg-gray-100 transition-colors'>
            <div className='w-16 h-16 md:w-20 md:h-20 bg-white rounded-2xl flex items-center justify-center mb-6 md:mb-8'>
              <svg
                className='w-8 h-8 md:w-10 md:h-10 text-[#FF6B35]'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={2}
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'
                />
              </svg>
            </div>
            <h3 className='text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4'>
              Fast Turnaround
            </h3>
            <p className='text-gray-700 text-sm md:text-base leading-relaxed'>
              Get reports within days, not weeks.
            </p>
          </div>

          {/* Confidential & Secure */}
          <div className='bg-gray-50 rounded-3xl p-8 md:p-10 lg:p-12 hover:bg-gray-100 transition-colors'>
            <div className='w-16 h-16 md:w-20 md:h-20 bg-white rounded-2xl flex items-center justify-center mb-6 md:mb-8'>
              <svg
                className='w-8 h-8 md:w-10 md:h-10 text-[#FF6B35]'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={2}
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z'
                />
              </svg>
            </div>
            <h3 className='text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4'>
              Confidential & Secure
            </h3>
            <p className='text-gray-700 text-sm md:text-base leading-relaxed'>
              We use advanced encryption to protect all data.
            </p>
          </div>

          {/* Expert Associates */}
          <div className='bg-gray-50 rounded-3xl p-8 md:p-10 lg:p-12 hover:bg-gray-100 transition-colors'>
            <div className='w-16 h-16 md:w-20 md:h-20 bg-white rounded-2xl flex items-center justify-center mb-6 md:mb-8'>
              <svg
                className='w-8 h-8 md:w-10 md:h-10 text-[#FF6B35]'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={2}
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
                />
              </svg>
            </div>
            <h3 className='text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4'>
              Expert Associates
            </h3>
            <p className='text-gray-700 text-sm md:text-base leading-relaxed'>
              Our network of verification associates ensures thorough, local-level checks.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
